import type { Tokens } from '@zeus/themes';

export function createAppBarStyles(tokens: Tokens) {
  return {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: tokens.ui.appBar.background,
          color: tokens.ui.appBar.foreground,
        },
      },
    },
  };
}
